import { ReactComponent as FlagIcon } from "./svg/ie-flag.svg";
import "../flag-icon.scss";

export const IEFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
